import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";

import logo from "../images/ckcLogo.png";
import hamburger from "../images/navBarHamburger.png";

const navItems = [
    { label: "ABOUT US", to: "/about" },
    { label: "WORKSHOP", to: "/workshop" },
    { label: "MEDIA", to: "/blogs" },
    { label: "JOIN US", to: "/intern" },
    { label: "SHOP", to: "/shop" },
    { label: "FAQS", to: "/faq" },
];

function NavBar() {
    const [isOpen, setIsOpen] = useState(false);

    const closeMenu = () => setIsOpen(false);

    return (
        <header className="nav-bar">
            <div className="nav-bar__inner">
                <Link className="nav-bar__brand" to="/" onClick={closeMenu}>
                    <img className="nav-bar__logo" src={logo} alt="" />
                    <span>Cultured Kids Cuisine</span>
                </Link>

                <button
                    className="nav-bar__toggle"
                    type="button"
                    aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={isOpen}
                    aria-controls="primary-navigation"
                    onClick={() => setIsOpen((open) => !open)}
                >
                    <img src={hamburger} alt="" />
                </button>

                <nav
                    id="primary-navigation"
                    className={`nav-bar__links${isOpen ? " nav-bar__links--open" : ""}`}
                    aria-label="Primary navigation"
                >
                    {navItems.map(({ label, to, accent }) => (
                        <Link
                            key={label}
                            className={`nav-bar__link${accent ? " nav-bar__link--accent" : ""}`}
                            to={to}
                            onClick={closeMenu}
                        >
                            {label}
                        </Link>
                    ))}
                </nav>
            </div>
        </header>
    );
}

export default NavBar;
